import { render, staticRenderFns } from "./earnings_breakdown.vue?vue&type=template&id=4ac2a24a&"
import script from "./earnings_breakdown.vue?vue&type=script&lang=js&"
export * from "./earnings_breakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports